import React from 'react';
import PostList from 'components/page-category/posts';
import { navigate } from 'gatsby';
import Container from 'container';
import Hero from 'components/templates-shared/hero';
import HeroFeatured from 'components/templates-shared/hero_featured';
import InfluencerStickerSlider from 'components/templates-shared/influencers_sticker_slider';
import Breadcrumbs from 'components/page-category/breadcrumbs';
import Pagination from 'components/page-category/pagination';
import AsideCategories from 'components/templates-aside/aside-categories';
import AsideSuggestInfl from 'components/templates-aside/aside-suggest-infl';
import AsideTopInflReq from 'components/templates-aside/aside-top-infls-req';
import Meta from 'shared/meta';
import 'styles/main.scss';

export default function PageTemplate({ pageContext }) {
  const defaultInfluencer = {
    influencer: {
      username: 'mr.miami',
      firstName: 'Matt',
      lastName: 'Werner',
      qualityScore: 60,
      category: {
        name: 'Fitness & Yoga'
      },
      featuredImage: {
        id: 'pgKq7IVksVF4k2dvYHF0',
        url:
          'https://www.googleapis.com/download/storage/v1/b/furlough-main.appspot.com/o/sktwidd9k0zn5lwr.png?generation=1569438501756011&alt=media'
      }
    }
  };
  const {
    posts,
    page,
    pages,
    category,
    top3Infl,
    influencer = defaultInfluencer,
    hero_image,
    meta
  } = pageContext;
  const breadcrumbs = [
    {
      name: 'Home',
      slug: '/'
    },
    {
      name: 'Category',
      slug: ''
    },
    {
      name: category.name,
      slug: category.slug
    }
  ];
  const isInfluencers = category.name === 'influencers';
  console.log(hero_image);
  return (
    <main>
      <Meta {...meta} />
      {isInfluencers ? (
        <Hero image={influencer.featuredImage?.id} title={category.name} blueOverlay />
      ) : (
        <Hero image={hero_image} title={category.name} blueOverlay />
      )}
      {isInfluencers && <InfluencerStickerSlider />}
      <Breadcrumbs breadcrumbs={breadcrumbs} />
      <Container className="category__container">
        <div className="category__wrapper">
          <div className="category__posts">
            <PostList articles={posts} title={category.name} />
          </div>
          <div className="category__asides">
            <AsideSuggestInfl />
            <AsideTopInflReq top3Infl={top3Infl} />
            <div className="category__sticky">
              <AsideCategories />
            </div>
          </div>
        </div>
      </Container>
      <Pagination
        ellipses={Array(pages)
          .fill()
          .map((_, i) => i + 1)} // creating array of shape "[1,2,3, ..., pages]"
        goto={navigate}
        page={page}
        prefix={category.slug}
      />
    </main>
  );
}
